<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="common_title">划转记录</div>

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="用户UID"
                clearable
                v-model="userId"
                class="userUid_ipt"
              >
                <!-- <img :src="userUid" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>

          <div class="item">
            <div class="ipt">
              <el-select v-model="tenantId" placeholder="租户选择" clearable>
                <el-option
                  v-for="item in tenantList"
                  :key="item.id"
                  :label="item.tenantName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">合约名称</div> -->
            <div class="ipt">
              <el-select
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="fromWalletType"
                placeholder="请选择"
              >
                <el-option value="" label="全部转出类型"></el-option>

                <el-option
                  v-for="item in fromOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">合约名称</div> -->
            <div class="ipt">
              <el-select
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="toWalletType"
                placeholder="请选择"
              >
                <el-option label="全部转入类型" value=""> </el-option>
                <el-option
                  v-for="item in toOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">合约名称</div> -->
            <div class="ipt">
              <el-select
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="status"
                placeholder="请选择"
              >
                <el-option label="全部状态" value=""> </el-option>
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </div>
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { STATUS, PAGINATION, FROM, TO } from "./constants";
import userUid from "@/assets/input/userUid.png";
import invite from "@/assets/input/invite.png";
import channel from "@/assets/input/channel.png";
import { tenantInfo } from "@/common/publicApi";
export default {
  name: "TransferRecord",
  components: {
    UserList,
  },
  data() {
    return {
      invite,
      channel,
      userUid,
      type: 1,
      dialogVisible: false,
      userId: "",
      channelId: "",
      channelUserId: "",
      positionId: "",
      billType: "",
      symbolId: "",
      value1: "",
      fromWalletType: "",
      toWalletType: "",
      status: "",
      statusOptions: STATUS,
      fromOptions: FROM,
      toOptions: TO,
      tenantList: [],
      tenantId: "",
    };
  },
  computed: {
    ...mapState("transferRecord", ["queryType", "queryTypeList", "pagination"]),
  },
  methods: {
    ...mapActions("transferRecord", ["list"]),

    ...mapMutations("transferRecord", ["setQueryType"]),
    refreshList(data = {}) {
      this.list({
        fromWalletType: this.fromWalletType,
        toWalletType: this.toWalletType,
        userId: this.userId,
        status: this.status,
        tenantId: this.tenantId,
        ...data,
      });
    },
    handleSearch() {
      this.list({
        fromWalletType: this.fromWalletType,
        toWalletType: this.toWalletType,
        userId: this.userId,
        status: this.status,
        tenantId: this.tenantId,
        ...PAGINATION,
      });
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });

    this.list({
      fromWalletType: this.fromWalletType,
      toWalletType: this.toWalletType,
      userId: this.userId,
      status: this.status,
      tenantId: this.tenantId,
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
